// import api from '../http/api'

export default {
    // 基础数据 => 服务大厅===========================================
    // GET_OVER_ALL(context, newAddId){
    //     api.getOverall().then(res => {
    //         let { schoolHall, assemblyDTOList: PageModuleList } = res.param;
    //         let { id, title, color, support, supportDisplay, schoolId } = schoolHall;
    //         color = Number(color);
    //         // 技术支持默认打开
    //         support = support === 0 ? false : true;
    //         let PageBasicData = {
    //             id,
    //             title, 
    //             color, 
    //             support,
    //             supportDisplay,
    //             schoolId,
    //         };
    //         // 触发mutations更改数据
    //         context.commit('GET_OVER_ALL', {PageBasicData, PageModuleList, newAddId});
    //     });
    // },

}